import { DownOutlined } from "@ant-design/icons";
import {
  Dropdown,
  MenuProps,
  Space,
  Table,
  Typography,
} from "antd";
import React, { useContext, useEffect, useState } from "react";
import { NavigationContext } from "../../../context/NavigationContext";
import { ToastContext } from "../../../context/ToastContext";
import AccountService from "../../../services/crud/AccountService";
import { ColumnType } from "antd/lib/table/interface";
import { RecoilState, useRecoilState } from "recoil";
import Hub from "../../../models/Hub";
import HubService from "../../../services/crud/HubService";
import { Modes } from "../../../Modes";
import AddHubButton from "./AddHubButton";

export const HubsTable = ({
  dataSource = undefined,
  hubsState,
  id,
  onDeleteSelected = async (key) => {},
} : {
  dataSource?: any,
  hubsState: RecoilState<Hub[]>,
  id?: number,
  onDeleteSelected?: any,
}) => {
  const { user, mode } = useContext(NavigationContext);

  const [hubs, setHubs] = useRecoilState(hubsState);
  const [filter, setFilter] = useState("");
  const { loading, loadMessage } = useContext(ToastContext);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  function loadTable(id) {
    if (id) {
      // Load all accounts for user
      loadMessage("Loading users...", () =>
        Promise.all([HubService.list({ accountId: id })]).then((data) => {
          setHubs(data[0]);
        })
      );
    }
  }
  useEffect(() => {
    if (dataSource) setHubs(dataSource);
  }, [dataSource]);
  useEffect(() => {
    if (id) loadTable(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, id]);

  const items: MenuProps["items"] = [
    {
      label: "Remove selected from account",
      key: "REMOVE_SELECTED_FROM_ACCOUNT",
    },
  ];
  const onClick = async ({ key }) => {
    switch (key) {
      case "REMOVE_SELECTED_FROM_ACCOUNT":
        await onDeleteSelected(selectedRowKeys);

        const results = await Promise.allSettled(
          selectedRowKeys.map((hubId) => {
            return AccountService.removeHub(id, `${hubId}`).then((data) => {
              return { data, id: hubId };
            });
          })
        );
        const success = results.filter((result) => result.status === "fulfilled").map((item: any) => item.value.id);
        const failed = results.filter((result) => result.status === "rejected");
        setHubs((prev) => prev.filter((hub) => !success.find((id) => id === hub.id)));
        console.log(success);
        console.log(failed);
        break;
    }
  };

  const columnns: ColumnType<Hub>[] = [
    {
      title: "Name",
      key: "name",
      dataIndex: ["name"],
      render: (text, record, index) => {
        return <Typography.Text>{text}</Typography.Text>;
      },
      // sorter: (a, b) => a?.type?.toLowerCase().localeCompare(b?.type?.toLowerCase()),
    },
    {
      title: "Address",
      key: "address",
      dataIndex: ["address"],
      render: (text, record, index) => {
        return <Typography.Text>{text}</Typography.Text>;
      },
      // sorter: (a, b) => a?.type?.toLowerCase().localeCompare(b?.type?.toLowerCase()),
    },
  ];

  // Row selection
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  console.log(hubs);
  let actionsDropdown = <></>;
  switch (mode) {
    case Modes.SYSTEM_ADMIN:
      actionsDropdown = (
        <Dropdown menu={{ items, onClick }} trigger={["click"]}>
          <a>
            <Space>
              Actions
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      );
      break;
    case Modes.COMPANY_ADMIN:
      actionsDropdown = (
        <Dropdown disabled menu={{}} trigger={["click"]}>
          <a>
            <Space>
              Actions
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      );
      break;
  }
  return (
    <div>
      <Typography.Title level={3}>Hubs</Typography.Title>
      <Space style={{ marginBottom: 10, justifyContent: "space-between", width: "100%" }}>
        <Space>
          {actionsDropdown}
          <span style={{ marginLeft: 8 }}> {`(Selected ${selectedRowKeys.length} items)`} </span>
        </Space>
        <AddHubButton accountId={id} hubsState={hubsState}></AddHubButton>
      </Space>

      <Table
        loading={loading}
        bordered
        rowKey="id"
        dataSource={hubs}
        rowSelection={rowSelection}
        columns={columnns}
        pagination={{ total: hubs.length, defaultPageSize: 30, showSizeChanger: true }}
        // onRow={(record) => ({ onClick: () => gotoPage(record.id) })}
        // loading={loading}
      />
    </div>
  );
}
